import * as actions from './events/actions'
import * as mutations from './events/mutations'
import * as getters from './events/getters'

const state = {
    filterText: '',
    list: []
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/events.js